import React from "react";
import { Sparkles } from "lucide-react";

export const ComingSoon = ({ title, description, Icon }) => (
  <div className="flex items-center justify-center min-h-[60vh]" data-testid="coming-soon">
    <div className="max-w-lg w-full text-center bg-white rounded-3xl border border-brand-soft p-10">
      <div className="w-16 h-16 rounded-2xl mx-auto bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center">
        {Icon ? <Icon className="w-8 h-8" /> : <Sparkles className="w-8 h-8" />}
      </div>
      <span className="inline-flex items-center gap-1.5 mt-6 px-4 py-1.5 rounded-full bg-brand-softer text-brand-greenDeep text-xs font-bold">
        <Sparkles className="w-3.5 h-3.5" /> Bientôt disponible
      </span>
      <h2 className="font-display text-3xl font-semibold text-brand-greenDeep mt-4">{title}</h2>
      <p className="text-brand-green/60 mt-3 leading-relaxed">
        {description || "Cette page est en cours de construction et sera disponible très prochainement."}
      </p>
    </div>
  </div>
);

export default ComingSoon;
